"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delete_client = void 0;
var api_1 = require("../../api");
var delete_client = function (req) {
    return (0, api_1.apiDelete)({
        endpoint: "v3/client/delete",
        data: req,
    });
};
exports.delete_client = delete_client;
